import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TrustCenterModalService } from '../../../../services/trustcenter-modals/trustcenter-modals.service';
import { BaseEvidenceDownloadComponent } from '../base-evidence-download/base-evidence-download.component';
import { Observable, firstValueFrom } from 'rxjs';
import { DownloadEvidenceParams } from '@anecdotes/shared-trust-center';
import { EvidenceTypeEnum } from '@anecdotes/api-contracts';

@Component({
  selector: 'app-evidence-download-summary',
  templateUrl: './evidence-download-summary.component.html',
  styleUrls: ['./evidence-download-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EvidenceDownloadSummaryComponent extends BaseEvidenceDownloadComponent implements OnInit, OnChanges {
  @Input({ required: true })
  evidence: DownloadEvidenceParams;

  canDownloadEvidence$: Observable<boolean>;

  isUrlEvidence: boolean;

  constructor(private trustCenterModalService: TrustCenterModalService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('evidence' in changes && !changes.evidence.firstChange) {
      this.initializeValues();
    }
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.initializeValues();
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.${key}`;
  }

  async requestAccess(): Promise<void> {
    const isPreviewMode = await firstValueFrom(this.isPreviewMode$);

    if (isPreviewMode) {
      return;
    }

    if (await firstValueFrom(this.isLoggedIn$)) {
      this.trustCenterModalService.openMissingPermissionModal();
    } else {
      this.trustCenterModalService.openRequestAccessModal();
    }
  }

  private initializeValues(): void {
    this.canDownloadEvidence$ = this.canDownloadEvidence(this.evidence);
    this.isUrlEvidence = this.evidence?.evidence_type === EvidenceTypeEnum.URL;
  }
}
